import { useEffect, useRef } from 'react';
import pick from 'lodash/pick';
import get from 'lodash/get';
import keys from 'lodash/keys';
import flow from 'lodash/flow';
import { pickKeys } from './constants';

export const mapSelectOptions = item => ({
  value: item.id,
  label: item.name,
});

const filterKeys = item => pick(item, pickKeys);
const getFilteredKeys = item => flow([filterKeys, keys])(item);

export const mapTableHeaderColumns = (tableData) => {
  const getFirstItem = items => get(items, '[0]', {});
  return flow([getFirstItem, getFilteredKeys])(tableData);
};
export const mapTableColumns = item => getFilteredKeys(item);

export const useTimeout = (handler, timeout) => {
  const timer = useRef();

  useEffect(() => function componentWillUnmount() {
    if (timer.current) {
      window.clearTimeout(timer.current);
    }
  }, []);

  return () => {
    if (timer.current) {
      window.clearTimeout(timer.current);
      timer.current = null;
    }

    timer.current = setTimeout(handler, timeout);
  };
};


const SHOW_TOP_NAV_ROUTES = [
  /(?:brand|barber)?\/products$/,
  /(?:brand|barber)?\/products\/categories$/,
  /(?:brand|barber)?\/products\/brands$/,
  /(?:brand|barber)?\/products\/inventory$/,
  /(?:brand|barber)?\/products\/shrinkage$/,
  /(?:brand|barber)?\/products\/valuation$/,
  /(?:brand|barber)?\/products\/purchase-orders\/locations$/,
  /(?:brand|barber)?\/products\/purchase-orders\/vendors$/,
];

export const showTopNavForContainerApp = pathname => SHOW_TOP_NAV_ROUTES.some(routeRegex => routeRegex.test(pathname));
